import { Navigate } from 'react-router-dom';
import { CircularProgress, Stack } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <Stack alignItems="center" justifyContent="center" className="min-h-[40vh]">
        <CircularProgress color="primary" />
      </Stack>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
}
